import { Component, OnInit, Input } from '@angular/core';

/**
 * Component per mostrar el marcador d'una benzinera
 */
@Component({
  selector: 'app-gas-station',
  templateUrl: './gas-station.component.html',
  styleUrls: ['./gas-station.component.css']
})
export class GasStationComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer; 

  /**
   * Conté les propietats del feature
   */
  properties; 

  /**
   * URL del logo de la gasolinera
   */
  iconUrl: string; 

  /**
   * Nom de la companyia 
   */
  company: string;

  /**
   * Direcció de la gasolinera
   */
  address: string;

  /**
   * Informació sobre l'horari de la gasolinera
   */
  timetable: string;

  /**
   * Preus dels carburants en aquesta gasolinera
   */
  prices;

  /**
   * Data a la qual fan referència els preus indicats
   */
  pricesDate: string;
  
  /**
   * Font d'informació
   */
  source: string;

  /**
   * @ignore
   */
  companiesLogo: string[] = ["BP","CAMPSA","CEPSA","GALP","PETRONOR","REPSOL","SHELL"]

  /**
   * @ignore
   */
  constructor() { }

  /**
   * inicialitza les propietats del component
   */
  ngOnInit() {

    this.properties = this.feature.properties;
    this.company = this.properties.company;
    this.iconUrl = this.getUrl();
    this.address = this.properties.address;
    this.timetable = this.properties.timetable;
    this.prices = this.properties.prices.price;
    this.prices = this.prices.filter(price => price.value !== '');
    this.pricesDate = this.properties.pricesDate;
    this.source = this.properties.source;
  }

  /**
   * Retorna la URL de la icona del marcador depenent de a quina capa pertany
   * @returns {string} URL de la icona del marcador depenent de a quina capa pertany
   */
  getUrl(){
    var url: string;
    var company = this.company.split(' ')[0];
    if(this.companiesLogo.includes(company)){
      url = 'assets/img/logo_' + company + '.gif';
    }
    else url = 'assets/img/' + this.layer + '_MARKER.svg';

    return url ;

  }

}
